<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Privacybeleid</h1>
      <p class="text-lg mb-12 text-center text-gray-400">
        Laatst bijgewerkt: {{ lastUpdated }}
      </p>

      <div class="space-y-8">
        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <h2 class="text-2xl font-semibold text-light">Gegevensverzameling</h2>
          </div>
          <p class="text-gray-300 leading-relaxed">
            Wij verzamelen alleen de gegevens die nodig zijn voor het functioneren van deze website
            en het verbeteren van uw gebruikerservaring. We delen uw gegevens nooit met derden zonder
            uw toestemming.
          </p>
        </section>

        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
              </svg>
            </div>
            <h2 class="text-2xl font-semibold text-light">Cookies</h2>
          </div>
          <p class="text-gray-300 leading-relaxed">
            Deze website gebruikt cookies om uw voorkeuren te onthouden en de website te verbeteren.
            U kunt cookies uitschakelen in uw browserinstellingen. Houd er rekening mee dat sommige
            functionaliteiten mogelijk niet beschikbaar zijn als cookies zijn uitgeschakeld.
          </p>
        </section>

        <section class="bg-dark-light p-8 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <h2 class="text-2xl font-semibold text-light">Gegevensbescherming</h2>
          </div>
          <p class="text-gray-300 leading-relaxed">
            Wij nemen de bescherming van uw gegevens serieus en volgen de geldende privacywetgeving,
            inclusief de Algemene Verordening Gegevensbescherming (AVG). Uw gegevens worden veilig
            opgeslagen en alleen gebruikt voor de doeleinden zoals beschreven in dit privacybeleid.
          </p>
        </section>
      </div>
    </div>
  </div>
</div>

